import React, { useState, useMemo } from "react"
// import { gql, useLazyQuery, useMutation } from '@apollo/client'
// import ThemeContext from '../ThemeContext'
import SelectQuantity from "../../components/SelectQuantity"
import Details from "../../components/Details"
import Confirm from "../../components/Confirm"
import Share from "../../components/Share"
import LoadingSpinner from "../../components/LoadingSpinner"
import ConfirmAppointmentCardSmall from "../../components/ConfirmAppointmentCardSmall"
import moment from "moment-timezone"

import Main from "./components/Main"

// Set default timezone
moment.tz.setDefault("America/New_York")

const Schedule = ({
  view,
  handleSetView,
  themeColor,
  categoryOptions,
  appointmentId,
  setAppointmentId,
}) => {
  const [appointments, setAppointments] = useState([])
  const [categorySelected, setCategorySelected] = useState("")
  const [loading] = useState(true)
  const [selectedEvent, setSelectedEvent] = useState()
  const [shared, setShared] = useState({})
  const [storeId, setStoreId] = useState()

  useMemo(() => {
    // Set view to share if appointmentId found and view.screen currently not share
    if (appointmentId && view.screen !== "share") {
      handleSetView("share")
    }
  }, [appointments])

  const appointmentsData = useMemo(() => {
    let data = {}
    appointments.forEach((app) => {
      data[app.relId] = app
    })

    return data
  }, [appointments])

  // useEffect(() => {
  //   async function getAppointments() {
  //     try {
  //       // const shop = window.location.ancestorOrigins[0].replace('https://', '')
  //       const urlParams = new URLSearchParams(window.location.search)
  //       const storeId = urlParams.get("store")

  //       const endpoints = [`/appointment-list/?shop=${storeId}`]

  //       const responses = await Promise.all(
  //         endpoints.map(async (url) => {
  //           const response = await fetch(
  //             `${process.env.REACT_APP_SERVER}${url}`
  //           )
  //           return await response.json()
  //         })
  //       )

  //       const appointments = responses[0].data ? responses[0].data : []

  //       setAppointments(appointments)
  //       setLoading(false)
  //     } catch (error) {
  //       console.log(error)
  //       setLoading(false)
  //     }
  //   }

  //   getAppointments()
  // }, [])

  // Update appointment quantity
  const updateQuantity = (idToUpdate, value, increment = false) => {
    const updatedAppointments = appointments.map((appointment) => {
      const { id, quantity, spots } = appointment
      if (idToUpdate === id) {
        const newVal = increment ? Number(quantity) + Number(value) : value
        if (
          newVal >= 0 &&
          newVal <= spots &&
          newVal <= selectedEvent.resource.spotsRemaining
        ) {
          appointment.quantity = newVal
        }
      }
      return appointment
    })

    setAppointments(updatedAppointments)
  }

  const handleSelect = (selection) => {
    setSelectedEvent()
    setCategorySelected(selection.value)
  }

  const addToCart = () => {
    if (selectedEvent && selectedEvent.start !== undefined) {
      const { start, end } = selectedEvent
      const eventId = selectedEvent.resource.eventId
      const { variantId, quantity } = appointmentsData[
        selectedEvent.resource.appointmentId
      ]
      const cartId = variantId.replace("gid://shopify/ProductVariant/", "")
      const eventType = selectedEvent.resource.recurring ? 1 : 0

      window.top.postMessage(
        {
          ctSchedule: {
            productId: cartId,
            quantity: quantity,
            eventId: eventId,
            eventType: eventType,
            date: moment(start).format("MM-DD-YYYY"),
            startTime: moment(start).format("hh:mm A"),
            endTime: moment(end).format("hh:mm A"),
            closeModal: true,
          },
        },
        "*"
      )
    } else {
      console.log("No event selected")
    }
  }

  return (
    <>
      <div className="ct-modal__body">
        {view.screen === "main" && (
          <Main
            categoryOptions={categoryOptions}
            categorySelected={categorySelected}
            handleSelect={handleSelect}
            themeColor={themeColor}
            updateQuantity={updateQuantity}
            handleSetView={handleSetView}
            setSelectedEvent={setSelectedEvent}
            selectedEvent={selectedEvent}
            appointmentsData={appointmentsData}
            setAppointments={setAppointments}
            storeId={storeId}
            setStoreId={setStoreId}
          />
        )}
        {view.screen === "details" && (
          <>
            <div className="ct-modal__control--spacing">
              {/* <button
                className="ct-modal__button"
                onClick={() => handleSetView("main")}
              >
                Back
              </button> */}
              {/* <SelectQuantity
                appointment={{
                  ...appointmentsData[selectedEvent.resource.appointmentId],
                  spots: selectedEvent.resource.spotsRemaining,
                }}
                color={themeColor}
                updateQuantity={updateQuantity}
                backButton={true}
                handleSetView={handleSetView}
                addToCart={addToCart}
                backButtonAction={() => {
                  // setAppointmentId()
                  handleSetView("main")
                }}
              /> */}
            </div>
            <Details
              color={themeColor}
              updateQuantity={updateQuantity}
              backButton={true}
              handleSetView={handleSetView}
              addToCart={addToCart}
              selectedEvent={selectedEvent}
              appointment={{
                ...appointmentsData[selectedEvent.resource.appointmentId],
                spotsRemaining: selectedEvent.resource.spotsRemaining,
              }}
            />
          </>
        )}
        {view.screen === "share" && (
          <>
            {loading && (
              <LoadingSpinner
                accessibilityLabel="Loading appointments"
                size="large"
                color="inkLightest"
              />
            )}
            {!loading && (
              <div className="ct-modal__control--spacing">
                <SelectQuantity
                  appointment={view.selectedAppointment}
                  color={themeColor}
                  updateQuantity={updateQuantity}
                  backButton={true}
                  handleSetView={handleSetView}
                  addToCart={addToCart}
                  shared={shared}
                  backButtonAction={() => {
                    setAppointmentId()
                    handleSetView("main")
                  }}
                />
              </div>
            )}
            {!loading && (
              <Share
                appointment={view.selectedAppointment}
                handleSetView={handleSetView}
                appointmentId={appointmentId}
                appointments={appointments}
                shared={shared}
                setShared={setShared}
                setSelectedEvent={setSelectedEvent}
              />
            )}
          </>
        )}
        {view.screen === "confirm" && (
          <>
            <Confirm
              appointment={view.selectedAppointment}
              handleSetView={handleSetView}
              setSelectedEvent={setSelectedEvent}
            />
          </>
        )}
      </div>
      {view.screen === "main" && (
        <div className="ct-modal__confirm-actions">
          <div className="ct-modal__confirm-actions-select">
            {selectedEvent && (
              <ConfirmAppointmentCardSmall
                appointment={
                  selectedEvent
                    ? appointmentsData[selectedEvent.resource.appointmentId]
                    : ""
                }
                selectedEvent={selectedEvent}
              />
            )}
            {selectedEvent && (
              <button
                className="ct-modal__button"
                style={{ marginLeft: "25px" }}
                onClick={() => handleSetView("details")}
              >
                Select
              </button>
            )}
          </div>
        </div>
      )}

      {view.screen === "details" && (
        <div className="ct-modal__confirm-actions">
          <SelectQuantity
            appointment={{
              ...appointmentsData[selectedEvent.resource.appointmentId],
              spots: selectedEvent.resource.spotsRemaining,
            }}
            color={themeColor}
            updateQuantity={updateQuantity}
            handleSetView={handleSetView}
            addToCart={addToCart}
            showTitle={true}
            backButton={true}
            backButtonAction={() => {
              setAppointmentId()
              handleSetView("main")
            }}
          />
        </div>
      )}

      {view.screen === "confirm" && (
        <div className="ct-modal__confirm-actions">
          <button
            className="ct-modal__button"
            onClick={() => handleSetView("main")}
          >
            Back
          </button>
          <button
            className="ct-modal__button"
            style={{ marginLeft: "25px" }}
            onClick={() => addToCart()}
          >
            Add to cart
          </button>
        </div>
      )}
    </>
  )
}

export default Schedule
